module.exports = __webpack_public_path__ + "static/media/golfmk7-2.e626cd73.webp";